angular.module('bmsApp.employee').factory('LoneWorkerPingSvc', function (CRUDSvc, LONE_WORKER_PING_API) {

	return {
		index: function (params) {
			return CRUDSvc.get(LONE_WORKER_PING_API.INDEX, params);
		},
		lastCheckIns: function (params) {
			return CRUDSvc.get(LONE_WORKER_PING_API.LAST_CHECKINS, params);
		},
	};

}).constant('LONE_WORKER_PING_API', {
	INDEX: 'api/employee/lone-worker-ping',
	LAST_CHECKINS: 'api/employee/last-check-ins',
});
